/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React from 'react'
import { useEffect,useCallback,useContext ,useState, useRef} from "react"
import { useDispatch,useSelector } from 'react-redux'
import { Link, useLocation,useParams,useSearchParams} from 'react-router-dom'
import TopHeader from '../../../../components/TopHeader'
import GlobalContext from '../../../../components/Context/GloablContext'
import Pagination from '../../../../components/Pagination'
import Limit from '../../../../components/Limit'
import CustomOverLay from '../../../../components/CustomOverLay'
import Emptyscreen from '../../../../components/EmptyScreen'
import ObserverActivityHistoryTopBar from '../../../ManageObserver/Components/ManageObserverActivityHistory/ManageObserverExportHistory/Components/Topbar'
import { useExportActivityHistoryExportLogMutation, useGetExportHistoryListQuery } from '../../../../features/activityHistorySlice'
import ManageExportTable from '../../../ManageMonitorUser/ManageMonitorActivityHistory/ManageMonitorExportHistory/Components/Table'

import {useGetHelpGuideAdminQuery} from '../../../../features/patientSlice'
import HelpGuideModal from '../../../../components/HelpGuideModal'


export default function ManageActivityExportHistory() {
    const {setToastmessage,Toastmessage,toastErrorMessage,setToastErrorMessage,isSideBar} = useContext(GlobalContext);
    const {username} = useParams()
    const [limit,setLimit]=useState("15")
    const [exportObserverExport]= useExportActivityHistoryExportLogMutation()
    const dispatch=useDispatch()
    const [suggestions,setSuggestions]=useState("")
    const [skip,setSkip]=useState(true)
    const location=useLocation()
    const locationStateRef = useRef(location.state)
    const [searchParams, setSearchParams] = useSearchParams({});
    const viewId=useSelector((state)=>state?.systemConfigData?.viewToHistory)
    const organization_id=useSelector((state)=>state?.systemConfigData?.organization_id)
    const [isColumnSelect,setIsColumnSelect] = useState(false)
    const {data,isFetching,isLoading,isError,status,isSuccess}=useGetExportHistoryListQuery(searchParams?.toString(),{skip:skip,refetchOnMountOrArgChange: true})
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
    const userType=localStorage?.getItem('user_type')!==null?localStorage.getItem('user_type'):sessionStorage.getItem('user_type')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    
    
    
    useEffect(() => {
        if (userType === 'corporate-user') {
            setQueryParamsadmin('type=admin-activity-history-view-export-history');
        } else {
            setQueryParamsadmin('type=admin-activity-history-view-export-history');
        }
    }, [userType]);
      
    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);

    // Retain location.state on first load
    useEffect(() => {
        if (location.state && !locationStateRef.current) {
            locationStateRef.current = location.state;
        }
    }, [location.state]);



    

    function handleNoOfRowsClick(number) {
        // setLoading(true);
        // let params = Object.fromEntries(searchParams);
        // params.page_number = 1;
        // params["limit"] = number;
        // params["target_organization"] = location.state[0];
        // params["filter"] = 'true';
        // setSearchParams({ ...params });

        let params = Object.fromEntries(searchParams);  
        params.page_number = 1;
        params.last_page= null
        params["limit"] = number;
        params['last_id']=null
        params['last_page'] =null
        setSearchParams({ ...params });
    
    }
    const handleOnClickPageNumber = (pageNum) => {
        // setLoading(true);
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum,last_id:(pageNum===1?null:searchParams?.get('page_number')>pageNum?(data?.data?.[0]?._id!==undefined?data?.data[0]?._id:null):(data?.data?.[data?.data?.length-1]?._id!==undefined?data?.data[data?.data?.length-1]?._id:null)),last_page:(pageNum===1?null:searchParams?.get('page_number')>pageNum?searchParams?.get('page_number'):searchParams?.get('page_number')) })
        // dispatch(addToTopCheckbox([pageNum.selected+1,searchParams.get("limit")]))
    }
    const handleSearchParams = (key, value) => {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1;
        params.last_page = null
        params.last_id = null
        if (key === 'search') {
            params[key] = encodeURIComponent(value);
        } else {
            params[key] = value;
        }
        if (params.search === '') delete params.search;
        setSearchParams({ ...params });
    }


    const handleDispatch = useCallback(() => {
        if (!searchParams.get('limit')) {
            handleSearchParams('limit', '15');
        }
        if (!searchParams.get('page_number')) {
            handleSearchParams('page_number', '1');
        }
        if (!searchParams.get('last_id')) {
            data===undefined?handleSearchParams('last_id', null):handleSearchParams('last_id', data?.data?.[data?.data?.length-1]?._id);
        }
        if (!searchParams.get('last_page')) {
            handleSearchParams('last_page', null)
        }
        
        
    }, [location]);
    useEffect(()=>{
        
        if(searchParams.size>=2 ){
            setSkip(false)
        }
       
        else{
            setSkip(true)
        }
    },[searchParams])
    /**
     * The function `handleSearchParams` updates the search parameters by setting the value of a
     * specific key and value, and then updating the search parameters state.
     */
  
    useEffect(() => {
        handleDispatch()
        
    }, [handleDispatch]);
    
   
    // const optimizedFn = useCallback(
    //     Debounce((value) => handleChange(value)),
    //     [searchParams]
    // );
    
   
    return (
        <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
            <TopHeader title={"Export History"}/>
            <div className='bg-white rounded-lg py-3 h-customh3 relative'>
                <div className="px-6">
                    <div className='flex items-center mb-3.5'>
                        <Link to={`/manage-activity-history?`} state={locationStateRef.current} >
                            <h1 className="text-sm font-normal text-[#52555D]">Activity History</h1>
                        </Link>
                        <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                        <div>
                            <h1 className="text-sm font-normal text-[#008586]">Export History</h1>
                        </div>
                        {
                            userType !=='super-admin' &&
                            <span   onClick={() => setHelpGuideModel(true)} className='ml-auto min-w-fit cursor-pointer'>
                                <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                            </span> 
                        }
                        
                    </div>
                    <ObserverActivityHistoryTopBar
                        path={'/manage-activity-history?'}
                        pathPlaceholder={'Go back to Activity History'}
                        suggestions={suggestions}
                        setSuggestions={setSuggestions}
                        data={data}
                        isExport={true}
                        exportCols={['Username','Timestamp','Filter Name','Table Name','Exported Column Name']}
                        isColumnSelect={isColumnSelect}
                        setIsColumnSelect={setIsColumnSelect}
                        lastActivityScreen={locationStateRef.current}
                        exportMonitorExport={exportObserverExport}
                        isIdexport={true}
                        isActivityHistory={true}
                    />
                </div>
                {((isFetching&&status!=="fulfilled"&&status!=="rejected")||(data===undefined&&status!=="fulfilled"&&status!=="rejected"))?<CustomOverLay Active text="Loading Export History..." classKey={`absolute top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center  ${isSideBar?'opened_sidebar_overlay1':'overlay-list1'}`}/>: (data!==undefined && data?.data?.length > 0 ) ? <>   
                    <div className="px-6">
                        <ManageExportTable
                            pageNumber={Number(searchParams.get('page_number')) || 1}
                            List={data}
                        />
                    </div>
                    {data?.total_count>=15&&<div className="w-full px-2.5 pt-1 flex items-center justify-between bg-[#F4F7FC]">
                        <p className="text-sm font-semibold text-[#687182]" id="total_records">Total Number of Records:{Math.ceil(parseInt(data?.total_count))}</p>
                        <div className="flex items-center">
                            <Limit
                                limit={limit}
                                setLimit={setLimit}
                                handleNoOfRowsClick={handleNoOfRowsClick}
                                isColumnSelect={isColumnSelect}
                            />
                        
                            <Pagination
                                TotalCount={parseInt(data?.total_count)}
                                totalPageNumber={Math.ceil(parseInt(data?.total_count)/parseInt(searchParams?.get("limit")))}
                                handleOnClickPageNumber={handleOnClickPageNumber}
                                // limit={Number(searchParams.get('limit'))}
                                limit={parseInt(limit)}
                            />
                        </div>
                    </div>}
                </>:<>
                    {data?.data.length===0 && 
                        <Emptyscreen  title={"Export History"}
                            FirstPTag={"No export history to view yet"} />
                    }
                </>}
                {(helpGuideModel && helpguidestatus==="fulfilled") &&
                <HelpGuideModal
                    setHelpGuideModel={setHelpGuideModel}
                    pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                />
                }

            </div>
        </div>
    )
}
